export const $ = (selector) => document.querySelector(selector);

export function createEl(tag, attrs = {}, children = []) {
  const element = document.createElement(tag);
  Object.entries(attrs).forEach(([key, value]) => {
    if (key === 'class') element.className = value;
    else if (key === 'text') element.textContent = value;
    else element.setAttribute(key, value);
  });
  (Array.isArray(children) ? children : [children]).filter(Boolean).forEach((child) => element.appendChild(child));
  return element;
}

export function clearSession() {
  ['lnf_token', 'lnf_user_id', 'lnf_is_admin'].forEach((key) => localStorage.removeItem(key));
  document.documentElement.classList.add('profile-auth-only');
  document.getElementById('currentMarkDisplay')?.replaceChildren();
  document.querySelectorAll('input[type="password"]').forEach((input) => { input.value = ''; });
  const checkbox = document.getElementById('agreeMembership');
  if (checkbox) checkbox.checked = false;
  const canvas = document.getElementById('signatureCanvas');
  if (canvas?.getContext) canvas.getContext('2d')?.clearRect(0, 0, canvas.width, canvas.height);
  window.dispatchEvent(new CustomEvent('lnf-auth-changed', { detail: { signedIn: false } }));
  window.dispatchEvent(new Event('lnf:session-cleared'));
}

export function isSignedIn() {
  const token = localStorage.getItem('lnf_token');
  if (!token) return false;
  try {
    const encoded = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(encoded));
    if (!payload.id || typeof payload.auth_subject !== 'string' || !payload.auth_subject
      || !Number.isSafeInteger(payload.session_version) || !Number.isFinite(payload.exp) || payload.exp * 1000 <= Date.now()) {
      clearSession();
      return false;
    }
    return true;
  } catch (_error) { clearSession(); return false; }
}

export async function jsonFetch(url, options = {}) {
  const token = localStorage.getItem('lnf_token');
  const headers = { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}), ...(options.headers || {}) };
  const response = await fetch(url, { ...options, headers });
  if (!response.ok) {
    let message = 'Request failed: ' + response.status;
    try { const body = await response.json(); message = body.error || body.message || message; } catch (_error) { /* Keep status message. */ }
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }
  return response.status === 204 ? null : response.json();
}

if (typeof window !== 'undefined' && !window.lnfSession) {
  window.lnfSession = { clear: clearSession, isSignedIn };
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, options = {}) => {
    const token = localStorage.getItem('lnf_token');
    const response = await originalFetch(input, options);
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.origin);
    const headers = new Headers(options.headers || (typeof input === 'object' ? input.headers : undefined));
    if (token && response.status === 401 && url.origin === window.location.origin && url.pathname.startsWith('/api/')
      && !['/api/auth/login', '/api/auth/register'].includes(url.pathname)
      && headers.get('Authorization') === 'Bearer ' + token && localStorage.getItem('lnf_token') === token) clearSession();
    return response;
  };
}
